import { Injectable } from '@angular/core';
import { Resetable } from '../../resetter/resetable';
import { Peripheral } from 'src/app/_model/peripheral';
import { MaterialDemand } from 'src/app/_model/material-demand';

@Injectable()
export abstract class MaterialDemandsDaoService implements Resetable {
  public abstract saveMaterialDemands(
    materialDemands: MaterialDemand[],
  ): Promise<void>;
  public abstract getMaterialDemands(): Promise<MaterialDemand[]>;
  public abstract reset(): Promise<void>;
  public abstract clear(): Promise<void>;
}
